import type { HomeInstitutionEventDto } from '@generated/unauth';

import { DONATION_ROUTES, WEBVIEW_TYPE_ENTRY } from '@/constants';

import { CARD_PROMOTIONS } from '../../_constants/cardEventBanners';

type MainBannerItem = {
  title: string;
  imageUrl: string;
  href: string;
  target?: string;
  eventId?: HomeInstitutionEventDto['eventId'];
};

export const filterMainBannerItems = (
  data: HomeInstitutionEventDto[],
  entry: string,
) => {
  const mainBannerItems: MainBannerItem[] =
    data
      ?.filter((item) => item && item.title)
      .map((item) => ({
        title: item.title,
        imageUrl: item.thumbnailUrl,
        href: DONATION_ROUTES.MY_ETC_EVENT_DETAIL.pathname({
          eventId: item.eventId,
        }),
        eventId: item.eventId,
      })) ?? [];

  const cardPromotions: MainBannerItem[] =
    entry === 'WELLO' ? [...CARD_PROMOTIONS.main] : [];

  const localMarketItem: MainBannerItem | null =
    entry === WEBVIEW_TYPE_ENTRY.WELLO
      ? {
          href: '/welmarket',
          title: '웰마켙 오픈',
          imageUrl:
            'https://cdn.welfarehello.com/static/local-market/home/hero-banner-pc-bg-1.png',
        }
      : null;

  const upgradeItem: MainBannerItem | null =
    entry !== WEBVIEW_TYPE_ENTRY.TOSS
      ? {
          href: '/community/policyInfo/1ea2bcd4-0705-4f32-a403-37fb3cae8910',
          title: '2026년 고향사랑기부제 공제율 최대 44% 확대',
          imageUrl:
            'https://cdn.welfarehello.com/static/banner/donation-upgrade.png',
        }
      : null;

  const sortedMainBannerItems: MainBannerItem[] = [
    localMarketItem,
    ...cardPromotions,
    upgradeItem,
    ...mainBannerItems,
    {
      href: 'https://blink.do/Wello',
      title: '연말정산 보험 환급액 확인하기',
      imageUrl: 'https://cdn.welfarehello.com/static/banner/signal.png',
    },
  ].filter(
    (item): item is NonNullable<typeof item> =>
      item !== null && item !== undefined,
  );

  return sortedMainBannerItems;
};
